import { Colors } from "@auteco/theme"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
    textField: {
        width: '300px',
        margin: '10px 20px 10px 0'
    },
    actionBtnsContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    actionBtn: {
        color: Colors.DARK_BLUE
    },
    cardContainer: {
        padding: '4px',
        background: Colors.GRAY_BACKGROUND
    }
}))

export default useStyles